// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c82ac5e5596c8c51f727","655":"c56de4d95d3256934949"}[chunkId] + ".js";
};